import {MailMessageState} from "./states/mail-message.state";

export const mailMessageState = [
    MailMessageState
];
